import React from 'react';
import Grid from '@material-ui/core/Grid';

import logo1 from '../../../images/LamarLogoAgproz.png';
import logo2 from '../../../images/LamarLogoQcify.png';
import logo3 from '../../../images/LamarLogoValleyH.png';
import logo4 from '../../../images/LamarLogoVarsity.png';
import logo5 from '../../../images/LamarLogoWF.png';

import { 
    StyledContainer,
    StyledGrid,
    StyledH2, 
    StyledP,
    StyledSection, 
    StyledLogo
} from './OurClients.style';

const OurClients = () => {
    return(
        <StyledSection id='clients'>
            <StyledContainer>
                <StyledP>COMPANIES THAT TRUST US</StyledP>
                <StyledH2>Our Clients</StyledH2>           
            </StyledContainer>
            <StyledGrid container justify='center' alignItems='center' spacing={3}>
                <Grid item xs={12} sm={6} md><StyledLogo src={logo1} alt='AgProz Logo'/></Grid>
                <Grid item xs={12} sm={6} md><StyledLogo src={logo2} alt='Qcify Logo'/></Grid>
                <Grid item xs={12} sm={6} md><StyledLogo src={logo3} alt='Valley Hackathon Logo'/></Grid>
                <Grid item xs={12} sm={6} md><StyledLogo src={logo4} alt='Varsity Logo'/></Grid>
                <Grid item xs={12} sm={6} md><StyledLogo src={logo5} alt='Workforce Development Logo'/></Grid>
            </StyledGrid>
        </StyledSection>    
    )
}

export default OurClients;